import type { RoomRoleName } from './stage-sync'

/**
 * Whether a presence diff's fresh joins (see `freshJoins` in `stage-sync`)
 * brought in someone who can actually answer a pending presenter request.
 *
 * The caller only needs a yes or no per diff, even when several moderators
 * reconnect at once: one re-send reaches every open moderator page, because
 * the request is a broadcast, not a message to one peer.
 */
export function moderatorRejoined(
  joinIds: string[],
  roleOf: (id: string) => RoomRoleName,
  selfId: string | null,
): boolean {
  return joinIds.some((id) => id !== selfId && (roleOf(id) === 'host' || roleOf(id) === 'cohost'))
}
